export default function MainTitle(){

    return(
        <div id="main-title">
            <h1>M<span>adej</span> S<span>ci</span>M<span>ath</span></h1>
        </div>
    ) 
}